import _throttle from 'lodash/throttle';
import { getWindowScrollTop, getWindowWidth, getWindowHeight, isMobileWidth, isPhabletWidth, isDesktopWidth } from 'js/helpers/device'; // TODO: is there a better place for this?

import store from 'js/store';
import { DEVICE_INFO_UPDATE } from '../reducers/nav/device';

function updateDeviceSizeInfo() {
  return {
    type: DEVICE_INFO_UPDATE,
    value: {
      windowWidth: getWindowWidth(),
      windowHeight: getWindowHeight(),
      isMobileWidth: isMobileWidth(),
      isPhabletWidth: isPhabletWidth(),
      isDesktopWidth: isDesktopWidth()
    }
  };
}

function updateDeviceScrollInfo() {
  return {
    type: DEVICE_INFO_UPDATE,
    value: {
      windowScrollTop: getWindowScrollTop()
    }
  };
}

var RESIZE_THROTTLE_TIME = 50;
var SCROLL_THROTTLE_TIME = 50;
export function beginListeningForDeviceChanges() {
  $(document).ready(function () {
    store.dispatch(updateDeviceSizeInfo());
    store.dispatch(updateDeviceScrollInfo()); // TODO: this shouldn't be necessary. The window width isn't always quite right on the mobile graph swiping stuff

    setTimeout(function () {
      store.dispatch(updateDeviceSizeInfo());
      store.dispatch(updateDeviceScrollInfo());
    }, 500);
    setTimeout(function () {
      store.dispatch(updateDeviceSizeInfo());
      store.dispatch(updateDeviceScrollInfo());
    }, 1000);
    $(window).resize(_throttle(function () {
      store.dispatch(updateDeviceSizeInfo());
    }, RESIZE_THROTTLE_TIME));
    $(window).on('scroll', _throttle(function () {
      store.dispatch(updateDeviceScrollInfo());
    }, SCROLL_THROTTLE_TIME));
  });
}
export function getIsMobileWidth() {
  return store.getState().device.isMobileWidth;
}
export function getIsPhabletWidth() {
  return store.getState().device.isPhabletWidth;
}